import { STORAGE_KEYS_CONSTANTS } from '@core/constants/storage-keys';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from './storage';

/**
 * Clase encargada de manejar el almacenamiento local o cache para el idioma.
 */
export class LanguageUtil {
  /** metodo que obtiene el idioma que se encuentre guardado en cache*/
  static getStorageLanguage(defaultlang?: string): string {
    return getLocalStorage(STORAGE_KEYS_CONSTANTS.LANGUAGE) || defaultlang || 'es';
  }

  /** metodo que actualiza el idioma que se encuentre guardado en cache*/
  static setStorageLanguage(lang: string): void {
    setLocalStorage(STORAGE_KEYS_CONSTANTS.LANGUAGE, lang);
  }

  /** metodo que limpia el cache del idioma */
  static clearStorage(): void {
    removeLocalStorage(STORAGE_KEYS_CONSTANTS.LANGUAGE);
  }
}
